module.exports = __webpack_public_path__ + "ec7dbcc334346ac754c424a9e87431a3.png";